// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AggregateReadResponseEuRange } from './AggregateReadResponseEuRange';
import {
    AggregateReadResponseEuRangeFromJSON,
    AggregateReadResponseEuRangeFromJSONTyped,
    AggregateReadResponseEuRangeToJSON,
    AggregateReadResponseEuRangeToJSONTyped,
} from './AggregateReadResponseEuRange';
import type { AggregateFunctionEnum } from './AggregateFunctionEnum';
import {
    AggregateFunctionEnumFromJSON,
    AggregateFunctionEnumFromJSONTyped,
    AggregateFunctionEnumToJSON,
    AggregateFunctionEnumToJSONTyped,
} from './AggregateFunctionEnum';
import type { HistoryDataValue } from './HistoryDataValue';
import {
    HistoryDataValueFromJSON,
    HistoryDataValueFromJSONTyped,
    HistoryDataValueToJSON,
    HistoryDataValueToJSONTyped,
} from './HistoryDataValue';

/**
 * Aggregated historical data response
 * @export
 * @interface AggregateReadResponse
 */
export interface AggregateReadResponse {
    /**
     * 
     */
    nodeId: string;
    /**
     * 
     */
    aggregateFunction: AggregateFunctionEnum;
    /**
     * Bucket size in milliseconds
     */
    processingInterval: number;
    /**
     * 
     */
    historyData: Array<HistoryDataValue>;
    /**
     * 
     */
    engineeringUnits?: string;
    /**
     * 
     */
    valuePrecision?: number;
    /**
     * 
     */
    euRange?: AggregateReadResponseEuRange;
}



/**
 * Check if a given object implements the AggregateReadResponse interface.
 */
export function instanceOfAggregateReadResponse(value: object): value is AggregateReadResponse {
    if (!('nodeId' in value) || value['nodeId'] === undefined) return false;
    if (!('aggregateFunction' in value) || value['aggregateFunction'] === undefined) return false;
    if (!('processingInterval' in value) || value['processingInterval'] === undefined) return false;
    if (!('historyData' in value) || value['historyData'] === undefined) return false;
    return true;
}

export function AggregateReadResponseFromJSON(json: any): AggregateReadResponse {
    return AggregateReadResponseFromJSONTyped(json, false);
}

export function AggregateReadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AggregateReadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nodeId': json['nodeId'],
        'aggregateFunction': AggregateFunctionEnumFromJSON(json['aggregateFunction']),
        'processingInterval': json['processingInterval'],
        'historyData': ((json['historyData'] as Array<any>).map(HistoryDataValueFromJSON)),
        'engineeringUnits': json['engineeringUnits'] == null ? undefined : json['engineeringUnits'],
        'valuePrecision': json['valuePrecision'] == null ? undefined : json['valuePrecision'],
        'euRange': json['euRange'] == null ? undefined : AggregateReadResponseEuRangeFromJSON(json['euRange']),
    };
}

export function AggregateReadResponseToJSON(json: any): AggregateReadResponse {
    return AggregateReadResponseToJSONTyped(json, false);
}

export function AggregateReadResponseToJSONTyped(value?: AggregateReadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nodeId': value['nodeId'],
        'aggregateFunction': AggregateFunctionEnumToJSON(value['aggregateFunction']),
        'processingInterval': value['processingInterval'],
        'historyData': ((value['historyData'] as Array<any>).map(HistoryDataValueToJSON)),
        'engineeringUnits': value['engineeringUnits'],
        'valuePrecision': value['valuePrecision'],
        'euRange': AggregateReadResponseEuRangeToJSON(value['euRange']),
    };
}

